"use strict";

import * as React from "react";
import RedTextInput from "./RedTextInput";

const UserContact = props => {
    const _handleEmailOnBlur = (e) => {
        props.onBlur(e);
    };

    const _handlePhoneNumberOnBlur = (e) => {
        props.onBlur(e);
    };

    const _handlePhoneNumberOnFocus = (e) => {
        props._handlePhoneNumberOnFocus();
    };

    const _handleEmailOnFocus = (e) => {
        props._handleEmailOnFocus();
    };

    return (
        <div id="UserContact" className="col-md-12 control-row">
            <div className="col-md-8">
                <div className="formControlTitle optionalField"><span>Email Address (Optional)</span></div>
                <RedTextInput id="emailAddress"
                    onChange={props.onEmailChange}
                    onBlur={_handleEmailOnBlur}
                    onFocus={_handleEmailOnFocus}
                    value={props.user.email}
                    style={{ width: "90%" }}
                    hasError={!props.emailIsValid}
                />
            </div>
            <div className="col-md-4">
                <div className="formControlTitle optionalField"><span>Phone Number (Optional)</span></div>
                <RedTextInput className="picker-hollow"
                    id="contactNumber"
                    onChange={props.setUserContactNumber}
                    onBlur={_handlePhoneNumberOnBlur}
                    onFocus={_handlePhoneNumberOnFocus}
                    value={props.user.phone}
                    hasError={!props.phoneIsValid}
                />
            </div>
            <div className="visibleHelpText col-md-12">
                <span>Email address is recommended for rule alert notifications.</span></div>
        </div>
    );
};

export default UserContact;
